import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Linkedin, Instagram, MessageCircle, Mail } from 'lucide-react';
import { FaPinterest } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Digital Marketing Strategy', path: '/services/digital-marketing-strategy' },
    { name: 'E-commerce Marketing', path: '/services/ecommerce-marketing' },
    { name: 'SEO Optimization', path: '/services/seo-optimization' },
    { name: 'Social Media Marketing', path: '/services/social-media-marketing' },
    { name: 'Paid Advertising', path: '/services/paid-advertising' },
    { name: 'Conversion Optimization', path: '/services/conversion-optimization' }
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.6 }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <motion.div className="footer-section" {...fadeInUp}>
          <h3>Kheenspro</h3>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', marginTop: '1rem', lineHeight: '1.6' }}>
            Growth. Strategy. Results.<br/>
            Helping brands scale and dominate online through data-driven digital marketing.
          </p>
          <div className="social-links" style={{ marginTop: '1.5rem' }}>
            {[
              { Icon: Linkedin, url: 'https://www.linkedin.com/in/oyetunde-ibrahim-b10355343' },
              { Icon: MessageCircle, url: 'https://wa.me/message/R2S5SGLV5TP5O1' },
              { Icon: Instagram, url: 'https://www.instagram.com/kheenspro' },
              { Icon: FaPinterest, url: 'https://pin.it/41roogNcw' }
            ].map(({ Icon, url }, index) => (
              <motion.a
                key={index}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                whileHover={{ scale: 1.2, rotate: 10, y: -5 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: 0.5 + index * 0.1 }}
              >
                <Icon size={18} />
              </motion.a>
            ))}
          </div>
        </motion.div>

        <motion.div 
          className="footer-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3>Services</h3>
          <ul>
            {services.map((service, index) => (
              <motion.li 
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                whileHover={{ x: 5, color: 'var(--brand-gold)' }}
              >
                <Link to={service.path}>{service.name}</Link>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        <motion.div 
          className="footer-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h3>Quick Links</h3>
          <ul>
            {quickLinks.map((link, index) => (
              <motion.li 
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                whileHover={{ x: 5, color: 'var(--brand-gold)' }}
              >
                <Link to={link.path}>{link.name}</Link>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        <motion.div 
          className="footer-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h3>Contact</h3>
          <ul>
            <motion.li whileHover={{ x: 5, color: 'var(--brand-gold)' }}>
              <a href="mailto:kheensproecom@gmail.com">
                <Mail size={16} style={{ display: 'inline-block', marginRight: '0.5rem', verticalAlign: 'middle' }} />
                kheensproecom@gmail.com
              </a>
            </motion.li>
            <motion.li whileHover={{ x: 5, color: 'var(--brand-gold)' }}>
              <a href="https://wa.me/message/R2S5SGLV5TP5O1" target="_blank" rel="noopener noreferrer">
                <MessageCircle size={16} style={{ display: 'inline-block', marginRight: '0.5rem', verticalAlign: 'middle' }} />
                Chat on WhatsApp
              </a>
            </motion.li>
          </ul>
        </motion.div>
      </div>

      <motion.div 
        className="footer-bottom"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.6 }}
      >
        <p>&copy; {currentYear} Kheenspro. All rights reserved. Built for brands that refuse to settle.</p>
      </motion.div>
    </footer>
  );
};

export default Footer;